export default __webpack_public_path__ + "static/sliding_door_b.df2f17e3ec873c5e4990f83d1f0f5e71.svg";